var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.tracklist),function(track,index){return _c('TracklistTile',{key:`${track.title} + ${track.artist} + ${index}`,attrs:{"track":track,"index":index + 1}})}),(_vm.tracklist.length === 0)?_c('BaseEmptyList',{attrs:{"error":_vm.error}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }